import { useId } from '@react-aria/utils'
import { SVGProps } from 'react'

export const ReactComponent = (props: SVGProps<SVGSVGElement>) => {
  const maskId = useId()
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" {...props}>
      <circle className="score10Bg" cx="15" cy="15" r="15" fill="#fff" fillOpacity="1" />
      <defs>
        <mask id={maskId} x="0" y="0" width="1" height="1">
          <circle cy="15" cx="15" r="100%" fill="#fff" />
          <path
            fill="#000"
            d="M13.2 9.4a1.6 1.6 0 1 0-2.4-2.3l-4.5 4.5c-.6.6-.6 1.7 0 2.3l4.5 4.5a1.6 1.6 0 1 0 2.4-2.3l-1.7-1.7h5.8c2.1 0 3.1 1.3 3.3 2.5.2 1.3-.5 2.8-2.3 3.3a1.6 1.6 0 1 0 .9 3.1c3.5-1 5-4 4.7-6.8-.4-3-2.8-5.4-6.6-5.4h-5.8l1.7-1.7Z"
          />
        </mask>
      </defs>
      <circle cx="15" cy="15" r="15" fill="#DD4066" mask={`url(#${maskId})`} />
    </svg>
  )
}
